<template>
  <Form :label-width="150" label-position="right" ref="params" :model="params" :rules="ruleValidate">
    <FormItem label="优惠券名称:" prop="cname">
      <label>
        <Input
          placeholder="请输入优惠券名称"
          style="width: 60%"
          v-model="params.cname"
        ></Input>
      </label>
    </FormItem>
    <!-- <FormItem label="发放平台:" prop="platformCodelist" v-if="this.mode==='add'&&params.ctype==='4'">
      <CheckboxGroup v-model="params.platformCodelist">
        <Checkbox v-for="(item,index) in CouponPlatform"
                  :key="index" :label=item.code>
          <span>{{ item.name }}</span>
        </Checkbox>
      </CheckboxGroup>
    </FormItem> -->
    <FormItem label="优惠券类型:" prop="ctype">
      <RadioGroup v-model="params.ctype">
        <Radio v-for="(v, k, i) in CoupontempType" :label="k"
               :key="i" border>
          <span>{{ v }}</span>
        </Radio>
      </RadioGroup>
    </FormItem>
    <Row v-show="params.ctype==='1'">
      <Row>
        <Col span="12">
          <FormItem>
            <Radio v-model="params.rule.meet.r1.ctype"
                   @on-change="changeMeetType('r1')"></Radio>
            <span style="padding-right: 20px;">满</span>
            <label>
              <InputNumber
                placeholder="金额"
                style="width: 70px;"
                :min="0"
                v-model="params.rule.meet.r1.amountstep"
              ></InputNumber>
            </label>
            <span style="padding-left: 10px;padding-right: 10px;">减</span>
            <label>
              <InputNumber
                placeholder="金额"
                style="width: 70px;"
                :min="0"
                v-model="params.rule.meet.r1.amount"
              ></InputNumber>
            </label>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="12">
          <FormItem>
            <Radio v-model="params.rule.meet.r2.ctype"
                   @on-change="changeMeetType('r2')"></Radio>
            <span style="padding-right: 10px;">每满</span>
            <label>
              <InputNumber
                placeholder="金额"
                style="width: 70px;"
                :min="0"
                v-model="params.rule.meet.r2.amountstep"
              ></InputNumber>
            </label>
            <span style="padding-left: 10px;padding-right: 10px;">减</span>
            <label>
              <InputNumber
                placeholder="金额"
                style="width: 70px;"
                :min="0"
                v-model="params.rule.meet.r2.amount"
              ></InputNumber>
            </label>
          </FormItem>
        </Col>
      </Row>
    </Row>
    <Row v-show="params.ctype==='2'">
      <Col span="12" offset="2">
        <FormItem label="固定金额:">
          <label>
            <InputNumber
              placeholder="固定金额"
              style="width: 70px;"
              :min="0"
              v-model="params.rule.fixed.amount"
            ></InputNumber>
          </label>
        </FormItem>
      </Col>
    </Row>
    <Row v-show="params.ctype==='3'">
      <Row>
        <Col span="12">
          <FormItem>
            <Radio v-model="params.rule.quantity.r1.ctype"
                   @on-change="changeQuanType('r1')"></Radio>
            <span style="padding-right: 20px;">满</span>
            <label>
              <InputNumber
                placeholder="数量"
                style="width: 70px;"
                :min="0"
                v-model="params.rule.quantity.r1.quantitystep"
              ></InputNumber>
            </label>
            <span style="padding-left: 10px;padding-right: 10px;">减</span>
            <label>
              <InputNumber
                placeholder="金额"
                style="width: 70px;"
                :min="0"
                v-model="params.rule.quantity.r1.amount"
              ></InputNumber>
            </label>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="12">
          <FormItem>
            <Radio v-model="params.rule.quantity.r2.ctype"
                   @on-change="changeQuanType('r2')"></Radio>
            <span style="padding-right: 10px;">每满</span>
            <label>
              <InputNumber
                placeholder="数量"
                style="width: 70px;"
                :min="0"
                v-model="params.rule.quantity.r2.quantitystep"
              ></InputNumber>
            </label>
            <span style="padding-left: 10px;padding-right: 10px;">减</span>
            <label>
              <InputNumber
                placeholder="金额"
                style="width: 70px;"
                :min="0"
                v-model="params.rule.quantity.r2.amount"
              ></InputNumber>
            </label>
          </FormItem>
        </Col>
      </Row>
    </Row>
    <Row v-show="params.ctype==='4'">
      <Col span="12">
        <FormItem>
          <span style="padding-left: 20px;padding-right: 10px;">启用数量:</span>
          <label>
            <InputNumber
              placeholder="启用数量"
              style="width: 70px;"
              :min="0"
              v-model="params.rule.discount.lmtcnt"
            ></InputNumber>
          </label>
          <span style="padding-left: 20px;padding-right: 10px;">折扣:</span>
          <label>
            <InputNumber
              placeholder="折扣(1-100)"
              style="width: 80px;"
              :min="0"
              :max="100"
              v-model="params.rule.discount.discount"
            ></InputNumber>
          </label><span style="padding-left: 10px;padding-right: 10px;">%</span>
        </FormItem>
      </Col>
    </Row>
    <FormItem label="启用金额:" prop="minAmount" required v-if="params.ctype==='4'">
      <label>
        <Input
          placeholder="请输入最小启用金额"
          :min="0"
          style="width: 60%"
          v-model="params.minAmount"
        ></Input>
      </label>
    </FormItem>
    <!-- <FormItem label="门店限领张数:" prop="lmtcnt" required v-if="params.ctype==='2'||params.ctype==='3'">
      <label>
        <InputNumber
          placeholder="请输入门店限领张数"
          :min="1"
          style="width: 60%"
          v-model="params.lmtcnt"
        ></InputNumber>
      </label>
    </FormItem> -->
    <FormItem label="有效期:" prop="expiredRange">
        <DatePicker type="datetimerange" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择有效期"
                    style="width:300px;" confirm :value="expiredRange"
                    @on-change="chooseExpiredDatetime"
        ></DatePicker>
      <!--      <FormItem prop="beginDate">-->
      <!--        <DatePicker type="date" format="yyyy-MM-dd" placeholder="开始日期"-->
      <!--                    v-model="params.beginDate"></DatePicker>-->
      <!--      </FormItem>-->
      <!--      <span style="padding-left: 10px;padding-right: 10px;">-</span>-->
      <!--      <FormItem prop="endDate">-->
      <!--        <DatePicker type="date" format="yyyy-MM-dd" placeholder="失效日期"-->
      <!--                    v-model="params.endDate"></DatePicker>-->
      <!--      </FormItem>-->
    </FormItem>
    <FormItem label="使用说明:" prop="couponDesc">
      <label>
        <Input
          placeholder="请输入使用说明"
          style="width: 60%" type="textarea" :autosize="true"
          v-model="params.couponDesc"
        ></Input>
      </label>
    </FormItem>
    <FormItem label="备注:" prop="remark" v-if="params.ctype!=='4'">
      <label>
        <Input
          placeholder="请输入"
          style="width: 60%" type="textarea" :autosize="true"
          v-model="params.remark"
        ></Input>
      </label>
    </FormItem>
    <FormItem label="是否返利券:" prop="isRebate" v-if="params.ctype!=='4'">
      <label>
        <i-switch v-model="params.isRebate" :trueValue="1" :falseValue="0" size="large">
           <span slot="open">是</span>
           <span slot="close">否</span>
        </i-switch>
      </label>
    </FormItem>
    <FormItem label="返利券类型:" prop="rebateType" v-if="params.ctype!=='4'&&params.isRebate">
      <label>
        <RadioGroup v-model="params.rebateType">
          <Radio v-for="(v, k, i) in rebateTypeList" :label="k"
                :key="i" border>
            <span>{{ v }}</span>
          </Radio>
        </RadioGroup>
      </label>
    </FormItem>
    <FormItem>
      <Button type="primary" @click="saveCoupon">{{
        mode === "edit" ? "修改" : "添加"
        }}
      </Button>
      <Button style="margin-left: 8px" @click="back">返回</Button>
    </FormItem>
  </Form>
</template>

<script>
  const validateLmtcnt = (rule, value, callback) => {
    if (value === '') {
      callback(new Error('请输入限领张数'));
    } else {
      if (value <= 0) {
        callback(new Error('限领张数必须大于0'));
      }
      callback();
    }
  };
  const validateAmount = (rule, value, callback) => {
    if (isNaN(value)) {
      callback(new Error('启用金额请输入数字'));
    } else if (value === '') {
      callback(new Error('请输入启用金额'));
    } else {
      if (value < 0) {
        callback(new Error('限领张数必须大于等于0'));
      }
      callback();
    }
  };
  export default {
    name: "create",
    data() {
      return {
        mode: '',
        CoupontempType: {},
        CouponPlatform: {},
        rebateTypeList: [
          "线上支付返利",
          "忠诚度返利",
          "素材转发返利",
          "货架陈列返利",
          "直播福利返利",
          "共享导购返利",
          "其他返利",
        ],
        params: {
          code: null,
          cname: '',
          platformCodelist: [],
          ctype: "1",
          rule: {
            meet: {
              r1: {ctype: true, amountstep: 0, amount: 0},
              r2: {ctype: false, amountstep: 0, amount: 0}
            },
            fixed: {amount: 0},
            quantity: {
              r1: {ctype: true, quantitystep: 0, amount: 0},
              r2: {ctype: false, quantitystep: 0, amount: 0}
            },
            discount: {lmtcnt: 0, discount: 100},
          },
          minAmount: 0,
          lmtcnt: 1,
          couponDesc: '',
          ruleDetail: '',
          remark: '',
          status: "0",
          beginDate: '',
          endDate: '',
          isRebate: 0,
          rebateType: 0,
        },
        expiredRange: ['', ''],
        ruleValidate: {
          cname: [
            {required: true, message: '请输入优惠券名称', trigger: 'blur'}
          ],
          platformCodelist: [
            {required: true, type: 'array', min: 1, message: '请至少选择一个平台', trigger: 'change'},
            {type: 'array', max: 2, message: '最多选择两个平台', trigger: 'change'}
          ],
          ctype: [
            {required: true, message: '请选择优惠券类型', trigger: 'blur'}
          ],
          minAmount: [
            {validator: validateAmount, trigger: 'blur'}
          ],
          lmtcnt: [
            {validator: validateLmtcnt, trigger: 'blur'}
          ],
          // expiredRange: [
          //   {validator: validateExpired, trigger: 'change'}
          // ],
          // beginDate: [
          //   {required: true, type: 'date', message: '请选择生效日期', trigger: 'change'}
          // ],
          // endDate: [
          //   {required: true, type: 'date', message: '请选择失效日期', trigger: 'change'}
          // ],
          couponDesc: [
            {required: true, message: '请输入使用说明', trigger: 'blur'}
          ],
        },
      };
    },
    methods: {
      chooseExpiredDatetime(v) {
        this.expiredRange = v;
      },
      changeMeetType(rtype) {
        if (rtype === 'r1') {
          this.params.rule.meet.r1.ctype = true;
          this.params.rule.meet.r2.ctype = false;
        }
        if (rtype === 'r2') {
          this.params.rule.meet.r1.ctype = false;
          this.params.rule.meet.r2.ctype = true;
        }
      },
      changeQuanType(rtype) {
        if (rtype === 'r1') {
          this.params.rule.quantity.r1.ctype = true;
          this.params.rule.quantity.r2.ctype = false;
        }
        if (rtype === 'r2') {
          this.params.rule.quantity.r1.ctype = false;
          this.params.rule.quantity.r2.ctype = true;
        }
      },
      queryCoupontemptype() {
        let http = 'couponTemplateType';
        this.$api[http]({}).then((res) => {
          if (res.code === '200') {
            //this.$Message.success('查询优惠券类型枚举成功');
            this.CoupontempType = res.data.CoupontempType;
          } else {
            this.$Message.error('查询优惠券类型枚举失败.');
          }
        });
      },
      queryBusiPlatform() {
        let http = 'couponqueryBusiPlatform';
        this.$api[http]({}).then((res) => {
          if (res.code === '200') {
            //this.$Message.success('查询优惠券业务平台枚举成功');
            this.CouponPlatform = res.data.CouponPlatform;
            this.params.platformCodelist = [];
            this.CouponPlatform.forEach(
              (p) => {
                this.params.platformCodelist.push(p.code);
              }
            );
          } else {
            this.$Message.error('查询优惠券业务平台枚举失败.');
          }
        });
      },
      saveCoupon() {
        if (this.mode === 'add') {
          this.addCouponTemplate();
        }
        if (this.mode === 'edit') {
          this.updateCouponTemplate();
        }
      },
      addCouponTemplate() {
        this.$refs['params'].validate((valid) => {
          if (valid) {
            if (this.expiredRange[0] === undefined || this.expiredRange[0] === '') {
              this.$Message.error("请选择有效期");
              return;
            }
            if (this.expiredRange[1] === undefined || this.expiredRange[1] === '') {
              this.$Message.error("请选择有效期");
              return;
            }
            this.params.beginDate = this.expiredRange[0];
            this.params.endDate = this.expiredRange[1];
            let http = 'createCouponTemplate';
            this.$api[http](this.params).then((res) => {
              if (res.code === '200') {
                this.$Message.success('创建优惠券模板成功');
                this.$router.go(-1);
              } else {
                this.$Message.error('创建优惠券模板失败.');
              }
            });
          } else {
            this.$Message.error('数据校验失败,请检查输入的数据.');
          }
        })
      },
      updateCouponTemplate() {
        this.$refs['params'].validate((valid) => {
          if (valid) {
            if (this.expiredRange[0] === undefined || this.expiredRange[0] === '') {
              this.$Message.error("请选择有效期");
              return;
            }
            if (this.expiredRange[1] === undefined || this.expiredRange[1] === '') {
              this.$Message.error("请选择有效期");
              return;
            }
            this.params.beginDate = this.expiredRange[0];
            this.params.endDate = this.expiredRange[1];
            let http = 'updateCouponTemplate';
            this.$api[http](this.params).then((res) => {
              if (res.code === '200') {
                this.$Message.success('修改优惠券模板成功');
                this.$router.go(-1);
              } else {
                this.$Message.error('修改优惠券模板失败.');
              }
            });
          } else {
            this.$Message.error('数据校验失败,请检查输入的数据.');
          }
        })
      },
      queryTemplateDetail() {
        let http = 'queryTemplateDetail';
        this.$api[http](this.params).then((res) => {
          if (res.code === '200') {
            this.$Message.success('查询优惠券模板信息成功');
            let c = res.data;
            this.params.code = c.code;
            this.params.cname = c.cname;
            this.params.platformCodelist = [];
            this.params.platformCodelist.push(c.platformCode);
            this.params.ctype = c.ctype.toString();
            this.params.minAmount = c.minAmount;
            this.params.lmtcnt = c.lmtCnt;
            this.params.status = c.status;
            this.params.beginDate = c.beginDate;
            this.params.endDate = c.endDate;
            this.expiredRange = ['', ''];
            this.expiredRange[0] = this.params.beginDate;//.replace(/-/g, "/");
            this.expiredRange[1] = this.params.endDate;//.replace(/-/g, "/");
            this.params.couponDesc = c.couponDesc;
            this.params.ruleDetail = c.ruleDetail;
            this.params.remark = c.remark;
            this.params.isRebate = c.isRebate;
            this.params.rebateType = c.rebateType;
            this.queryRuleDetail();
          } else {
            this.$Message.error('查询优惠券模板失败.');
          }
        });
      },
      queryRuleDetail() {
        let rule = JSON.parse(this.params.ruleDetail);
        if (this.params.ctype === '1') {
          let meetr = {ctype: true, amountstep: rule.amountStep, amount: rule.amount};
          if (rule.cType === '0') {
            this.params.rule.meet.r1 = meetr;
            this.params.rule.meet.r2.ctype = false;
          }
          if (rule.cType === '1') {
            this.params.rule.meet.r2 = meetr;
            this.params.rule.meet.r1.ctype = false;
          }
        }
        if (this.params.ctype === '2') {
          this.params.rule.fixed.amount = rule.amount;
        }
        if (this.params.ctype === '3') {
          let quanr = {ctype: true, quantitystep: rule.quantityStep, amount: rule.amount};
          if (rule.cType === '0') {
            this.params.rule.quantity.r1 = quanr;
            this.params.rule.quantity.r2.ctype = false;
          }
          if (rule.cType === '1') {
            this.params.rule.quantity.r2 = quanr;
            this.params.rule.quantity.r1 = false;
          }
        }
        if (this.params.ctype === '4') {
          this.params.rule.discount.lmtcnt = rule.lmtCnt;
          this.params.rule.discount.discount = rule.discount * 100;
        }
        // let query = {
        //   templateCode: this.params.code,
        //   ruleType: this.params.ctype
        // };
        // let http = 'queryRuleDetail';
        // this.$api[http](query).then((res) => {
        //   if (res.code === '200') {
        //     let rule = res.data;
        //     if (this.params.ctype === '1') {
        //       let meetr = {ctype: true, amountstep: rule.amountStep, amount: rule.amount};
        //       if (rule.ctype === '0') {
        //         this.params.rule.meet.r1 = meetr;
        //         this.params.rule.meet.r2.ctype = false;
        //       }
        //       if (rule.ctype === '1') {
        //         this.params.rule.meet.r2 = meetr;
        //         this.params.rule.meet.r1.ctype = false;
        //       }
        //     }
        //     if (this.params.ctype === '2') {
        //       this.params.rule.fixed.amount = rule.amount;
        //     }
        //     if (this.params.ctype === '3') {
        //       let quanr = {ctype: true, quantitystep: rule.quantityStep, amount: rule.amount};
        //       if (rule.ctype === '0') {
        //         this.params.rule.quantity.r1 = quanr;
        //         this.params.rule.quantity.r2.ctype = false;
        //       }
        //       if (rule.ctype === '1') {
        //         this.params.rule.quantity.r2 = quanr;
        //         this.params.rule.quantity.r1 = false;
        //       }
        //     }
        //     if (this.params.ctype === '4') {
        //       this.params.rule.discount.lmtcnt = rule.lmtCnt;
        //       this.params.rule.discount.discount = rule.discount * 100;
        //     }
        //   }
        // });
      },
      back() {
        this.$router.back();
      },
    },
    created() {
      this.params.code = this.$route.query.code;
      if (this.params.code) {
        this.mode = 'edit';
        this.queryTemplateDetail();
      } else {
        this.mode = 'add';
      }
      this.queryBusiPlatform();
      this.queryCoupontemptype();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/coupon/template/create.vue